import { useEffect, useState } from "react";
import Button from "../../Components/Button";
import CardHU from "../../Components/CardHU";
import Footer from "../../Components/Footer";
import { HUForm } from "../../Components/HUForm";
import { ListCardBox } from "../../Components/ListCardBox";
import ModalElement from "../../Components/Modal";
import { useHabUnits } from "../../Providers/HabUnit";
import { useUser } from "../../Providers/User";
import { HUContainer, Container, CardsContainer } from "./styles";

const UnitHabits = () => {
  const { AdmHUList, listHUs } = useHabUnits();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { admAuth } = useUser();

  const handleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  useEffect(() => {
    listHUs();
  }, []);

  useEffect(() => {}, [AdmHUList]);

  return (
    <Container>
      <HUContainer>
        <ListCardBox style={{ height: "80vh" }}>
          {AdmHUList?.map((el) => (
            <CardHU key={el.id} data={el} isInPage={false} />
          ))}
          {admAuth && (
            <Button
              onClick={handleModal}
              className="addButton"
              style={{
                backgroundColor: "var(--secondary-color)",
                borderRadius: "5px 5px 50px 5px",
                minWidth: "252px",
                maxWidth: "300px",
                width: "90%",
                padding: "2rem 1rem 5px",
                position: "relative",
                margin: "0.5rem",
                height: "168px",
              }}
            >
              +
            </Button>
          )}
        </ListCardBox>
        <ModalElement isOpen={modalIsOpen} closeModal={handleModal}>
          <HUForm closeModal={handleModal} />
        </ModalElement>
      </HUContainer>
      <Footer />
    </Container>
  );
};
export default UnitHabits;
